module.exports = __webpack_public_path__ + "static/media/second_home.897c1b97.png";